import type React from "react";
import type { ReactNode } from "react";
import styled from "styled-components";

interface GradientCardProps {
	children: ReactNode;
	gradientColors?: [string, string];
	borderWidth?: number;
	borderRadius?: number;
	height?: string;
	width?: string;
	padding?: string;
	greenGradient?: boolean;
}

const CardWrapper = styled.div<{
	$gradientColors: [string, string];
	$borderWidth: number;
	$borderRadius: number;
	$height: string;
	$width: string;
	$padding: string;
	$greenGradient: boolean;
}>`
	display: flex;
	background-color: black;
	border-radius: ${(props) => props.$borderRadius}px;
	padding: ${(props) => props.$padding};
	justify-content: space-between;
	align-items: center;
	position: relative;
	overflow: hidden;
	height: ${(props) => props.$height};
	width: ${(props) => props.$width};
	isolation: isolate;
	&::before {
		content: "";
		position: absolute;
		inset: -${(props) => props.$borderWidth}px;
		background: linear-gradient(
			to bottom,
			${(props) => props.$gradientColors[0]},
			${(props) => props.$gradientColors[1]}
		);
		background: ${(props) =>
			props.$greenGradient
				? "hsla(0, 0.00%, 100.00%, 0.30)"
				: `linear-gradient(
					to bottom,
					${props.$gradientColors[0]},
					${props.$gradientColors[1]}
				)`};

		z-index: -1;
		border-radius: ${(props) => props.$borderRadius + props.$borderWidth}px;
	}

	&::after {
		content: "";
		position: absolute;
		inset: 1px;
		background: ${(props) =>
			props.$greenGradient
				? "linear-gradient(180deg, rgba(20, 23, 21, 0.95) 0%, rgba(11, 19, 16, 0.98) 50%, rgba(18, 50, 36, 1) 100%)"
				: "black"};
		border-radius: ${(props) => props.$borderRadius - 1}px;
		z-index: -1;
	}
`;

export const GradientCardImage = styled.div`
	position: absolute;
	inset: 1px;
	z-index: 0;
	overflow: hidden;
	border-radius: inherit;
`;

export const GradientCard: React.FC<GradientCardProps> = ({
	children,
	gradientColors = ["white", "#494e4c"],
	borderWidth = 2,
	borderRadius = 16,
	height = "auto",
	width = "100%",
	padding = "160px 64px",
	greenGradient = false,
	...props
}) => {
	return (
		<CardWrapper
			$gradientColors={gradientColors}
			$borderWidth={borderWidth}
			$borderRadius={borderRadius}
			$height={height}
			$width={width}
			$padding={padding}
			$greenGradient={greenGradient}
			{...props}
		>
			{children}
		</CardWrapper>
	);
};
